<!--
 * @FileDescription: 未出账
 * @Author: 陈文景
 * @Date: 2022-12-27 09:34:13
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <PageSkeletonTabs>
    <template slot="header-left">
      <el-select v-model="parameter.userGroups" multiple collapse-tags filterable clearable size="medium" placeholder="请选择用户类型" @change="getUnpublishedBillsList">
        <el-option v-for="item in userTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <el-select v-if="false" v-model="parameter.packStatusList" multiple collapse-tags filterable clearable size="medium" placeholder="请选择订单状态" @change="getUnpublishedBillsList">
        <el-option v-for="item in packStatusListOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <div class="select-picker">
        <el-select v-model="parameter.dateType" size="medium" placeholder="请选择" @change="onSelectDateType">
          <el-option label="付款时间" :value="1" />
          <el-option label="发货时间" :value="2" />
          <el-option label="出账日期" :value="3" />
        </el-select>
        <el-date-picker v-model="parameter.dateTime" size="medium" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="changeDatePicker" />
      </div>

      <BatchSearch :option="searchConditionOptins" :selected="parameter.searchType" @select="searchType" @search="search" @clear="clear" />

      <!-- <el-button @click="dataExport" style="height: 36px; margin-left: 10px">数据导出</el-button> -->
    </template>

    <template slot="header-right">
      <el-button :disabled="!multipleSelection.length" size="medium" @click="onBatchGenerateBills">批量生成账单</el-button>

      <el-button size="medium" @click="onAutomaticRepaymentSettings">账期自动还款设置</el-button>
    </template>

    <template slot="container">
      <el-table v-loading="loading" :data="bills" size="medium" row-key="id" :style="{ width: `${tableWidth}%` }" :height="`${tableHeight}%`" @sort-change="onTableSortChange" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="50" />
        <el-table-column prop="kkOrderId" label="订单号" />
        <el-table-column prop="packId" label="包裹单号">
          <template v-slot="{ row }">
            {{ defaultTips(row.packId) }}
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱/手机号">
          <template slot-scope="{row}">
              <div>{{ row.email }}</div>
              <div>{{ row.phone }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="应收款(USD)" sortable="custom">
          <template v-slot="{ row }">
            {{ amount(row.amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="userGroup" label="用户类型">
          <template v-slot="{ row }">
            {{ userGroup(row.userGroup) }}
          </template>
        </el-table-column>
        <el-table-column label="kaka付款时间">
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.paymentDate)) }}
          </template>
        </el-table-column>
        <el-table-column prop="deliveryDate" label="发货时间" sortable="custom">
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.deliveryDate)) }}
          </template>
        </el-table-column>
        <el-table-column prop="billingDateStr" label="出账日" sortable="custom">
          <template v-slot="{ row }">
            {{ defaultTips(row.billingDateStr) }}
          </template>
        </el-table-column>
        <el-table-column label="订单发货状态">
          <template v-slot="{ row }">
            {{ fulfillmentStatus(row.fulfillmentStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="包裹状态">
          <template v-slot="{ row }">
            {{ packStatus(row.packStatus) }}
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #footer-right>
      <el-pagination background :page-sizes="[20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total" :current-page="parameter.pageNumber" @size-change="sizeChange" @current-change="currentChange" />
    </template>

    <!-- 批量生成账单对话框 -->
    <BatchGenerationDialog ref="batchGenerationDialog" @update="getUnpublishedBillsList" />

    <!-- 账期自动付款设置对话框 -->
    <AutomaticPaymentDialog ref="automaticPaymentDialog" />
    <!-- 账期导出对话框 -->
    <BillExport ref="billExport" :parameter="parameter" />
  </PageSkeletonTabs>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'
import PageSkeletonTabs from './PageSkeletonTabs.vue'
import BatchSearch from '@/components/BatchSearch.vue'
import BatchGenerationDialog from './BatchGenerationDialog.vue'
import AutomaticPaymentDialog from './AutomaticPaymentDialog.vue'
import BillExport from './BillExport.vue'

let parameter = {
  userGroups: [], // 用户分组: -1.默认 100.独立站
  packStatusList: [], // 包裹状态: 准备中preparing 已取消cancelled 已发货shipped 已完成completed
  fulfillmentStatusList: [], // 订单发货状态: waiting_to_ship待发货 fully_shipped已发货 partial_shipped部分发货
  dateTime: null, // 时间选择器双向绑定的值(请求前需删除该字段)
  dateType: 1, // 选择的时间类型(请求前需删除该字段)
  paymentDateStart: undefined, // 付款时间- 开始
  paymentDateEnd: undefined, // 付款时间-截止
  deliveryDateStart: undefined, // 发货时间- 开始
  deliveryDateEnd: undefined, // 发货时间-截止
  billingDateStart: undefined, // 出账日期- 开始
  billingDateEnd: undefined, // 出账日期- 截止
  searchType: 2, // 根据条件类型搜索双向绑定的值(请求前需删除该字段)
  kkOrderIds: [], // 订单号数组
  emails: [], // 用户邮箱数组
  sortType: undefined, // 排序类型 1.应收款 2.付款时间 3.发货时间 4.出账日期(为空则按更新时间降序)
  sort: undefined, // 升降序排序: asc.升序 desc.降序
  pageSize: 20,
  pageNumber: 1
}

export default {
  components: {
    BatchSearch,
    PageSkeletonTabs,
    BatchGenerationDialog,
    AutomaticPaymentDialog,
    BillExport
  },
  data() {
    return {
      formatTimeStamp,

      tableWidth: 100,
      tableHeight: 100,

      // 用户类型下拉选项
      userTypeOptions: [
        { label: '独立站', value: 100 },
        { label: '默认', value: -1 }
      ],

      // 订单状态下拉选项
      packStatusListOptions: [
        { label: '准备中', value: 'preparing' },
        { label: '已取消', value: 'cancelled' },
        { label: '已发货', value: 'shipped' },
        { label: '已完成', value: 'completed' }
      ],

      // 根据条件类型搜索下拉选项
      searchConditionOptins: [
        { label: '订单号', value: 1 },
        { label: '邮箱/手机号', value: 2 }
      ],

      parameter: { ...parameter },
      total: 0, // 权限列表总数量
      loading: false,
      bills: [],
      multipleSelection: []
    }
  },
  computed: {
    amount() {
      return (value) => {
        return value ? `US$${value}` : '-'
      }
    },
    userGroup() {
      return (value) => {
        switch (value) {
          case -1:
            return '默认'
          case 100:
            return '独立站'
          default:
            return '-'
        }
      }
    },
    packStatus() {
      return (value) => {
        switch (value) {
          case 'preparing':
            return '准备中'
          case 'cancelled':
            return '已取消'
          case 'shipped':
            return '已发货'
          case 'completed':
            return '已完成'
          default:
            return '-'
        }
      }
    },
    fulfillmentStatus() {
      return (value) => {
        switch (value) {
          case 'waiting_to_ship':
            return '待发货'
          case 'fully_shipped':
            return '已发货'
          case 'partial_shipped':
            return '部分发货'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  activated() {
    this.getUnpublishedBillsList()
  },
  methods: {
    /**
     * API 获取权限列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getUnpublishedBillsList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let parameter = { ...this.parameter }
        delete parameter.dateTime
        delete parameter.dateType
        delete parameter.searchType
        let { data } = await API.getUnpublishedBillsList(parameter)
        this.bills = data.list
        this.total = data.total
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 选择日期筛选类型
     *
     * @param {Number} value 当前选中的类型
     */
    onSelectDateType(value) {
      if (this.parameter.dateTime) {
        // 付款时间
        if (value === 1) {
          if (this.parameter.deliveryDateStart && this.parameter.deliveryDateEnd) {
            this.parameter.paymentDateStart = this.parameter.deliveryDateStart
            this.parameter.paymentDateEnd = this.parameter.deliveryDateEnd
            this.parameter.deliveryDateStart = undefined
            this.parameter.deliveryDateEnd = undefined
            this.parameter.billingDateStart = undefined
            this.parameter.billingDateEnd = undefined
          }
          if (this.parameter.billingDateStart && this.parameter.billingDateEnd) {
            this.parameter.paymentDateStart = this.parameter.billingDateStart
            this.parameter.paymentDateEnd = this.parameter.billingDateEnd
            this.parameter.deliveryDateStart = undefined
            this.parameter.deliveryDateEnd = undefined
            this.parameter.billingDateStart = undefined
            this.parameter.billingDateEnd = undefined
          }
        }
        // 发货时间
        if (value === 2) {
          if (this.parameter.paymentDateStart && this.parameter.paymentDateEnd) {
            this.parameter.deliveryDateStart = this.parameter.paymentDateStart
            this.parameter.deliveryDateEnd = this.parameter.paymentDateEnd
            this.parameter.paymentDateStart = undefined
            this.parameter.paymentDateEnd = undefined
            this.parameter.billingDateStart = undefined
            this.parameter.billingDateEnd = undefined
          }
          if (this.parameter.billingDateStart && this.parameter.billingDateEnd) {
            this.parameter.deliveryDateStart = this.parameter.billingDateStart
            this.parameter.deliveryDateEnd = this.parameter.billingDateEnd
            this.parameter.paymentDateStart = undefined
            this.parameter.paymentDateEnd = undefined
            this.parameter.billingDateStart = undefined
            this.parameter.billingDateEnd = undefined
          }
        }
        // 出账日期
        if (value === 3) {
          console.info(value)
          if (this.parameter.paymentDateStart && this.parameter.paymentDateEnd) {
            this.parameter.billingDateStart = this.parameter.paymentDateStart
            this.parameter.billingDateEnd = this.parameter.paymentDateEnd
            this.parameter.deliveryDateStart = undefined
            this.parameter.deliveryDateEnd = undefined
            this.parameter.paymentDateStart = undefined
            this.parameter.paymentDateEnd = undefined
          }
          if (this.parameter.deliveryDateStart && this.parameter.paymentDateEnd) {
            this.parameter.billingDateStart = this.parameter.deliveryDateStart
            this.parameter.billingDateEnd = this.parameter.paymentDateEnd
            this.parameter.deliveryDateStart = undefined
            this.parameter.deliveryDateEnd = undefined
            this.parameter.paymentDateStart = undefined
            this.parameter.paymentDateEnd = undefined
          }
        }
        this.getUnpublishedBillsList()
      }
    },

    /**
     * 时间日期选择器的回调事件
     *
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        // 付款时间
        if (this.parameter.dateType === 1) {
          this.parameter.paymentDateStart = date[0]
          this.parameter.paymentDateEnd = date[1]
          this.parameter.deliveryDateStart = undefined
          this.parameter.deliveryDateEnd = undefined
          this.parameter.billingDateStart = undefined
          this.parameter.billingDateEnd = undefined
        }
        // 发货时间
        if (this.parameter.dateType === 2) {
          this.parameter.deliveryDateStart = date[0]
          this.parameter.deliveryDateEnd = date[1]
          this.parameter.paymentDateStart = undefined
          this.parameter.paymentDateEnd = undefined
          this.parameter.billingDateStart = undefined
          this.parameter.billingDateEnd = undefined
        }
        // 出账日期
        if (this.parameter.dateType === 3) {
          this.parameter.billingDateStart = date[0]
          this.parameter.billingDateEnd = date[1]
          this.parameter.deliveryDateStart = undefined
          this.parameter.deliveryDateEnd = undefined
          this.parameter.paymentDateStart = undefined
          this.parameter.paymentDateEnd = undefined
        }
      } else {
        this.parameter.paymentDateStart = undefined
        this.parameter.paymentDateEnd = undefined
        this.parameter.deliveryDateStart = undefined
        this.parameter.deliveryDateEnd = undefined
        this.parameter.billingDateStart = undefined
        this.parameter.billingDateEnd = undefined
      }
      this.getUnpublishedBillsList()
    },

    /**
     * 选择搜索类型的回调
     *
     * @param {String} value 当前选中的值
     */
    searchType(value) {
      this.parameter.searchType = value
    },

    /**
     * 搜索按钮触发的回调
     *
     * @param {String} value
     */
    search(value) {
      // 订单号
      if (this.parameter.searchType === 1) {
        this.parameter.kkOrderIds = value.split(',').map((item) => item.trim())
        this.parameter.emails = []
      }
      // 用户邮箱
      if (this.parameter.searchType === 2) {
        this.parameter.emails = value.split(',').map((item) => item.trim())
        this.parameter.kkOrderIds = []
      }
      this.getUnpublishedBillsList()
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    clear() {
      this.parameter.emails = []
      this.parameter.kkOrderIds = []
      this.getUnpublishedBillsList()
    },

    /**
     * 当表格的排序条件发生变化的时候会触发该事件
     *
     * @param {Object} value 排序对象
     */
    onTableSortChange({ prop, order }) {
      if (order) {
        this.parameter.sortType = prop === 'amount' ? 1 : prop === 'paymentDate' ? 2 : prop === 'deliveryDate' ? 3 : prop === 'billingDateStr' ? 4 : undefined
        this.parameter.sort = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined
      } else {
        this.parameter.sortType = undefined
        this.parameter.sort = undefined
      }
      this.getUnpublishedBillsList()
    },

    /**
     * 批量生成账单
     */
    onBatchGenerateBills() {
      this.$refs.batchGenerationDialog.show(this.multipleSelection)
    },

    /**
     * 账期自动还款设置
     */
    onAutomaticRepaymentSettings() {
      this.$refs.automaticPaymentDialog.show()
    },

    /**
     * 当选择项发生变化时会触发该事件
     *
     * @param {Array} selection
     */
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },

    /**
     * 展示导出对话框
     */
     dataExport() {
      this.$refs.billExport.show()
    },

    /**
     * 每页显示条数发生改变时的回调
     *
     * @param {Number} size 每页显示条数
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getUnpublishedBillsList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param {Number} current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getUnpublishedBillsList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-picker {
  display: inline-block;
  .el-select {
    width: 108px;
    /deep/.el-input__inner {
      border-right: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .el-range-editor.el-input__inner {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
</style>
